import { useAppSelector } from '@hooks/app/redux';
import { getClientDetail } from '@services/external/client.api';
import { useQuery, UseQueryOptions } from 'react-query';

async function handler(providerId: string, clientId: string) {
  const { data } = await getClientDetail(providerId, clientId);

  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function useClientDetail(
  clientId: string,
  options?: UseQueryOptions<TQueryData | null, unknown, TQueryData, any>,
) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  return useQuery(
    ['client:detail', providerId, clientId],
    () => handler(providerId, clientId),
    options,
  );
}

export default useClientDetail;
